import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next';
import { useAppDesignCompanyLogo, useConfigEditMode } from '../../../store/selectors/configurationSelector';
import { useAppDispatch } from '../../../hooks/StoreHooks';
import { setAppDesignCompanyLogo, setAppDesignCompanyLogoBase64 } from '../../../store/reducers/configurationReducer';
import { theme } from '../../../theme';
import UploadIcon from "@mui/icons-material/Upload";
import { Box, Button, Typography } from '@mui/material';
import { GeneralButton } from '../../../common/ui/GeneralButton';

const AppDesignCompanyLogo = () => {
    const { t } = useTranslation();

    let currentCompanyLogoUrl = useAppDesignCompanyLogo()
    let editMode = useConfigEditMode()
    const dispatch = useAppDispatch();

    const hiddenFileInput = useRef<HTMLInputElement>(null);
    const imageRef = useRef(null);

    const handleClick = () => {
        hiddenFileInput.current && hiddenFileInput.current.click();
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            dispatch(setAppDesignCompanyLogo(URL.createObjectURL(e.target.files[0])));
            const reader = new FileReader();
            reader.onload = onReaderLoaded
            reader.readAsBinaryString(e.target.files[0])
        }
    };

    const onReaderLoaded = (readerEvt: any) => {
        let binaryString = readerEvt.target.result;
        dispatch(setAppDesignCompanyLogoBase64(btoa(binaryString)));
    }

    const displayedLogoUrl = currentCompanyLogoUrl;

    return (
        <Box>
            <Typography variant='h5'>
                {t("configurationPage.appDesign.companyLogo")}
            </Typography>

            <Box sx={{ mt: 1 }}>
                {displayedLogoUrl
                    ? <img src={displayedLogoUrl} ref={imageRef} width="150px" alt="a" />
                    : t("configurationPage.appDesign.noCompanyLogo")
                }
            </Box>

            {editMode &&
                <Box sx={{ mt: 1 }}>
                    <GeneralButton
                        appVariant="secondary"
                        onClick={handleClick}
                    >
                        <input
                            type="file"
                            ref={hiddenFileInput}
                            accept="image/gif, image/jpeg, image/png"
                            hidden
                            onChange={handleChange}
                        />
                        <UploadIcon sx={{ mr: 1 }} />
                        {t("buttons.select")}
                    </GeneralButton>
                </Box>
            }
        </Box>
    )
}

export default AppDesignCompanyLogo